import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { Offer } from '../../Offer';
import image from '../images/mite.png';

export const Mite = () => {
  const handleClick = () => {
    pushEvent(
      makeMainGEvent({
        eventCategory: 'Клещ',
        eventAction: 'Сезонные предложения',
      }),
    );
  };

  return (
    <Offer
      title={'Кешбэк 20% на страховку\nот укуса клеща'}
      subtitle={'Действует по всей России\nс покрытием до 2 000 000 ₽'}
      color="green"
      href={'/strahovka-ot-klescha/?promoCode=ilovesravni/'}
      image={image}
      onClick={handleClick}
    />
  );
};
